const classNames =
{
    notificationBubble: "notificationBubble",
};

export function updateNumber(notificationContainerId: string, number: number, animate?: boolean)
{
    updateBubbleNumber(getBubble(notificationContainerId), number, animate);
}

export function increment(notificationContainerId: string, numberToAdd?: number, animate?: boolean)
{
    const bubble = getBubble(notificationContainerId);
    if (!bubble)
    {
        return;
    }
    numberToAdd = cleanNumber(numberToAdd);

    const newNumber = getNumberFromBubble(bubble) + numberToAdd;
    updateBubbleNumber(bubble, newNumber, animate);
}

export function decrement(notificationContainerId: string, numberToSubtract?: number, animate?: boolean)
{
    const bubble = getBubble(notificationContainerId);
    if (!bubble)
    {
        return;
    }
    numberToSubtract = cleanNumber(numberToSubtract);

    const newNumber = getNumberFromBubble(bubble) - numberToSubtract;
    updateBubbleNumber(bubble, newNumber, animate);
}

function getBubble(notificationContainerId: string)
{
    const bubble = $('#' + notificationContainerId).find(`.${classNames.notificationBubble}`);
    return (bubble.length == 0) ? null : bubble;
}

function getNumberFromBubble(bubble: JQuery<HTMLElement>)
{
    return parseInt(bubble.text());
}

function cleanNumber(number?: number)
{
    return (number == undefined || isNaN(number)) ? 1 : number;
}

function updateBubbleNumber(bubble: JQuery<HTMLElement> | null, number: number, animate?: boolean)
{
    if (animate == undefined)
    {
        animate = true;
    }
    if (!bubble)
    {
        return;
    }
    if (number == 0)
    {
        bubble.fadeOut(function ()
        {
            bubble.text(number);
        });
    }
    else
    {
        if (animate)
        {
            bubble.fadeOut(300, function ()
            {
                bubble.text(number).fadeIn(300);
            });
        }
        else
        {
            bubble.text(number);
        }
    }
}